<template>
  <b-row>
    <div class="col-12 col-lg-9">
      <b-card class="mb-3" :header="heading" no-body>
        <div class="card-body">
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="Name:">
                <b-form-input
                  id="form-input-name"
                  name="form-input-name"
                  v-model="itemForm.name"
                  v-validate="{ required: true, min: 1 }"
                  :state="validateState('form-input-name')"
                  data-vv-as="Name"
                  />
                <b-form-invalid-feedback id="form-input-name-feedback">
                  {{ veeErrors.first('form-input-name') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Processing System:">
                <b-form-select
                  id="form-input-processingSystem"
                  name="form-input-processingSystem"
                  v-model="itemForm.processingSystem"
                  v-validate="{ required: true }"
                  :state="validateState('form-input-processingSystem')"
                  :options="processingSystemOptions"
                  data-vv-as="Processing System"
                />
                <b-form-invalid-feedback id="form-input-processingSystem-feedback">
                  {{ veeErrors.first('form-input-processingSystem') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Carrier:">
                <b-v-select
                  id="form-input-tplCarrierId"
                  name="form-input-tplCarrierId"
                  v-model="itemForm.tplCarrierId"
                  v-validate="{ required: false }"
                  :state="validateState('form-input-tplCarrierId')"
                  :searchable="true"
                  :options="tplCarrierList"
                  data-vv-as="TPL Carrier"
                />
                <b-form-invalid-feedback id="form-input-tplCarrierId-feedback">
                  {{ veeErrors.first('form-input-tplCarrierId') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Description:">
                <b-form-textarea
                  id="form-input-description"
                  name="form-input-description"
                  v-model="itemForm.description"
                  v-validate="{ required: false }"
                  :state="validateState('form-input-description')"
                  data-vv-as="Description"
                  rows="3"
                  placeholder="Short description about this specific integration"
                />
                <b-form-invalid-feedback id="form-input-description-feedback">
                  {{ veeErrors.first('form-input-description') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Tracking Base URL:">
                <b-form-input
                  id="form-input-trackingBaseUrl"
                  name="form-input-trackingBaseUrl"
                  v-model="itemForm.trackingBaseUrl"
                  v-validate="{ required: false }"
                  :state="validateState('form-input-trackingBaseUrl')"
                  data-vv-as="Tracking Base URL"
                  placeholder="https://example.com/track/{trackingNumber}"
                  />
                <b-form-invalid-feedback id="form-input-trackingBaseUrl-feedback">
                  {{ veeErrors.first('form-input-trackingBaseUrl') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Filter By Country Code:">
                <b-form-input
                  id="form-input-filterByCountryCode"
                  name="form-input-filterByCountryCode"
                  v-model="itemForm.filterByCountryCode"
                  v-validate="{ required: false }"
                  :state="validateState('form-input-filterByCountryCode')"
                  data-vv-as="Filter By Country Code"
                  placeholder="US, CA, MX (comma-separated)"
                  />
                <b-form-invalid-feedback id="form-input-filterByCountryCode-feedback">
                  {{ veeErrors.first('form-input-filterByCountryCode') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <!-- API Configuration - Dynamic based on Processing System -->
      <b-card class="mb-3" :header="getApiConfigHeader()" no-body>
        <div class="card-body">
          <b-row>
            <!-- ShipEngine Configuration -->
            <template v-if="itemForm.processingSystem === 'ShipEngine'">
              <b-col cols="12" md="6">
                <b-form-group label="ShipEngine API Key:">
                  <b-form-input
                    id="form-input-apiKey1"
                    name="form-input-apiKey1"
                    v-model="itemForm.apiKey1"
                    type="password"
                      autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey1')"
                    data-vv-as="ShipEngine API Key"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey1-feedback">
                    {{ veeErrors.first('form-input-apiKey1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="ShipEngine Carrier ID:">
                  <b-form-input
                    id="form-input-shipEngineCarrierId"
                    name="form-input-shipEngineCarrierId"
                    v-model="itemForm.shipEngineCarrierId"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-shipEngineCarrierId')"
                    data-vv-as="ShipEngine Carrier ID"
                    />
                  <b-form-invalid-feedback id="form-input-shipEngineCarrierId-feedback">
                    {{ veeErrors.first('form-input-shipEngineCarrierId') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </template>

            <!-- UPSDirect Configuration -->
            <template v-else-if="itemForm.processingSystem === 'UPSDirect'">
              <b-col cols="12" md="4">
                <b-form-group label="UPS App API Key:">
                  <b-form-input
                    id="form-input-apiKey1"
                    name="form-input-apiKey1"
                    v-model="itemForm.apiKey1"
                    type="text"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey1')"
                    data-vv-as="UPS App API Key"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey1-feedback">
                    {{ veeErrors.first('form-input-apiKey1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group label="UPS App API Secret:">
                  <b-form-input
                    id="form-input-apiKey2"
                    name="form-input-apiKey2"
                    v-model="itemForm.apiKey2"
                    type="text"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey2')"
                    data-vv-as="UPS App API Secret"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey2-feedback">
                    {{ veeErrors.first('form-input-apiKey2') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group label="UPS Account Number:">
                  <b-form-input
                    id="form-input-apiKey3"
                    name="form-input-apiKey3"
                    v-model="itemForm.apiKey3"
                    type="password"
                      autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey3')"
                    data-vv-as="UPS Access Key"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey3-feedback">
                    {{ veeErrors.first('form-input-apiKey3') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </template>

            <!-- TechShip Configuration -->
            <template v-else-if="itemForm.processingSystem === 'TechShip'">
              <b-col cols="12" md="6">
                <b-form-group label="TechShip API Key:">
                  <b-form-input
                    id="form-input-apiKey1"
                    name="form-input-apiKey1"
                    v-model="itemForm.apiKey1"
                    type="password"
                      autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey1')"
                    data-vv-as="TechShip API Key"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey1-feedback">
                    {{ veeErrors.first('form-input-apiKey1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="TechShip Secret:">
                  <b-form-input
                    id="form-input-apiKey2"
                    name="form-input-apiKey2"
                    v-model="itemForm.apiKey2"
                    type="password"
                      autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey2')"
                    data-vv-as="TechShip Secret"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey2-feedback">
                    {{ veeErrors.first('form-input-apiKey2') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </template>

            <!-- GlobalAccess Configuration -->
            <template v-else-if="itemForm.processingSystem === 'GlobalAccess'">
              <b-col cols="12" md="6">
                <b-form-group label="Global Access API Key:">
                  <b-form-input
                    id="form-input-apiKey1"
                    name="form-input-apiKey1"
                    v-model="itemForm.apiKey1"
                    type="password"
                      autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey1')"
                    data-vv-as="Global Access API Key"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey1-feedback">
                    {{ veeErrors.first('form-input-apiKey1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </template>

            <!-- GLS Germany Configuration -->
            <template v-else-if="itemForm.processingSystem === 'GLSGermany'">
              <b-col cols="12" md="6">
                <b-form-group label="Username:">
                  <b-form-input
                    id="form-input-apiKey1"
                    name="form-input-apiKey1"
                    v-model="itemForm.apiKey1"
                    type="text"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey1')"
                    data-vv-as="Username"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey1-feedback">
                    {{ veeErrors.first('form-input-apiKey1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Password:">
                  <b-form-input
                    id="form-input-apiKey2"
                    name="form-input-apiKey2"
                    v-model="itemForm.apiKey2"
                    type="password"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey2')"
                    data-vv-as="Password"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey2-feedback">
                    {{ veeErrors.first('form-input-apiKey2') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Contact ID:">
                  <b-form-input
                    id="form-input-apiKey3"
                    name="form-input-apiKey3"
                    v-model="itemForm.apiKey3"
                    type="text"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey3')"
                    data-vv-as="Contact ID"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey3-feedback">
                    {{ veeErrors.first('form-input-apiKey3') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </template>

            <!-- Deutsche Post DHL Configuration -->
            <template v-else-if="itemForm.processingSystem === 'DeutschePostDHL'">
              <b-col cols="12" md="6">
                <b-form-group label="GKP Username:">
                  <b-form-input
                    id="form-input-apiKey3"
                    name="form-input-apiKey3"
                    v-model="itemForm.apiKey3"
                    type="text"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey3')"
                    data-vv-as="GKP Username"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey3-feedback">
                    {{ veeErrors.first('form-input-apiKey3') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="GKP Password:">
                  <b-form-input
                    id="form-input-apiKey4"
                    name="form-input-apiKey4"
                    v-model="itemForm.apiKey4"
                    type="password"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey4')"
                    data-vv-as="GKP Password"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey4-feedback">
                    {{ veeErrors.first('form-input-apiKey4') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Client ID:">
                  <b-form-input
                    id="form-input-apiKey1"
                    name="form-input-apiKey1"
                    v-model="itemForm.apiKey1"
                    type="text"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey1')"
                    data-vv-as="Client ID"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey1-feedback">
                    {{ veeErrors.first('form-input-apiKey1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Client Secret:">
                  <b-form-input
                    id="form-input-apiKey2"
                    name="form-input-apiKey2"
                    v-model="itemForm.apiKey2"
                    type="password"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey2')"
                    data-vv-as="Client Secret"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey2-feedback">
                    {{ veeErrors.first('form-input-apiKey2') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Account Number:" description="Your DHL account number (e.g. 33333333).">
                  <b-form-input
                    id="form-input-customField1"
                    name="form-input-customField1"
                    v-model="itemForm.customField1"
                    type="text"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-customField1')"
                    data-vv-as="Account Number"
                    />
                  <b-form-invalid-feedback id="form-input-customField1-feedback">
                    {{ veeErrors.first('form-input-customField1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Participation Number:" description="Two-digit service participation number (e.g. 01). Combined with Account Number and service routing number to build the billing number.">
                  <b-form-input
                    id="form-input-customField2"
                    name="form-input-customField2"
                    v-model="itemForm.customField2"
                    type="text"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-customField2')"
                    data-vv-as="Participation Number"
                    placeholder="01"
                    />
                  <b-form-invalid-feedback id="form-input-customField2-feedback">
                    {{ veeErrors.first('form-input-customField2') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </template>

            <!-- FedEx Configuration -->
            <template v-else-if="itemForm.processingSystem === 'Fedex'">
              <b-col cols="12" md="6">
                <b-form-group label="Client ID:" description="Your FedEx API key (client id).">
                  <b-form-input
                    id="form-input-apiKey1"
                    name="form-input-apiKey1"
                    v-model="itemForm.apiKey1"
                    type="text"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey1')"
                    data-vv-as="Client ID"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey1-feedback">
                    {{ veeErrors.first('form-input-apiKey1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Client Secret:" description="Your FedEx API secret key.">
                  <b-form-input
                    id="form-input-apiKey2"
                    name="form-input-apiKey2"
                    v-model="itemForm.apiKey2"
                    type="password"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey2')"
                    data-vv-as="Client Secret"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey2-feedback">
                    {{ veeErrors.first('form-input-apiKey2') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </template>

            <!-- GOFO Configuration -->
            <template v-else-if="itemForm.processingSystem === 'GOFO'">
              <b-col cols="12" md="6">
                <b-form-group label="Username:">
                  <b-form-input
                    id="form-input-apiKey1"
                    name="form-input-apiKey1"
                    v-model="itemForm.apiKey1"
                    type="text"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey1')"
                    data-vv-as="Username"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey1-feedback">
                    {{ veeErrors.first('form-input-apiKey1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Password:">
                  <b-form-input
                    id="form-input-apiKey2"
                    name="form-input-apiKey2"
                    v-model="itemForm.apiKey2"
                    type="password"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey2')"
                    data-vv-as="Password"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey2-feedback">
                    {{ veeErrors.first('form-input-apiKey2') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Base URL:" description="Override the default API base URL (https://na-api.cirroecommerce.com). Leave blank to use default.">
                  <b-form-input
                    id="form-input-authToken"
                    name="form-input-authToken"
                    v-model="itemForm.authToken"
                    type="text"
                    autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-authToken')"
                    data-vv-as="Base URL"
                    placeholder="https://na-api.cirroecommerce.com"
                    />
                  <b-form-invalid-feedback id="form-input-authToken-feedback">
                    {{ veeErrors.first('form-input-authToken') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </template>

            <!-- Fake Carrier Configuration (testing only) -->
            <template v-else-if="itemForm.processingSystem === 'FakeCarrier'">
              <b-col cols="12">
                <b-alert show variant="warning">
                  <strong>Testing Only</strong> — Fake Carrier generates random tracking numbers and fake label URLs. No credentials are required. Do not use in production.
                </b-alert>
              </b-col>
            </template>

            <!-- Generic Configuration for other systems -->
            <template v-else>
              <b-col cols="12" md="4">
                <b-form-group label="API Key 1:">
                  <b-form-input
                    id="form-input-apiKey1"
                    name="form-input-apiKey1"
                    v-model="itemForm.apiKey1"
                    type="password"
                      autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey1')"
                    data-vv-as="API Key 1"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey1-feedback">
                    {{ veeErrors.first('form-input-apiKey1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group label="API Key 2:">
                  <b-form-input
                    id="form-input-apiKey2"
                    name="form-input-apiKey2"
                    v-model="itemForm.apiKey2"
                    type="password"
                      autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey2')"
                    data-vv-as="API Key 2"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey2-feedback">
                    {{ veeErrors.first('form-input-apiKey2') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group label="API Key 3:">
                  <b-form-input
                    id="form-input-apiKey3"
                    name="form-input-apiKey3"
                    v-model="itemForm.apiKey3"
                    type="password"
                      autocomplete="off"
                    v-validate="{ required: false }"
                    :state="validateState('form-input-apiKey3')"
                    data-vv-as="API Key 3"
                    />
                  <b-form-invalid-feedback id="form-input-apiKey3-feedback">
                    {{ veeErrors.first('form-input-apiKey3') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </template>
          </b-row>
        </div>
      </b-card>

      <!-- OAuth Token Configuration (if applicable) -->
      <b-card v-if="showOAuthSection" class="mb-3" header="OAuth Configuration" no-body>
        <div class="card-body">
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="Auth Token:">
                <b-form-input
                  id="form-input-authToken"
                  name="form-input-authToken"
                  v-model="itemForm.authToken"
                  type="password"
                      autocomplete="off"
                  v-validate="{ required: false }"
                  :state="validateState('form-input-authToken')"
                  data-vv-as="Auth Token"
                  />
                <b-form-invalid-feedback id="form-input-authToken-feedback">
                  {{ veeErrors.first('form-input-authToken') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Refresh Token:">
                <b-form-input
                  id="form-input-refreshToken"
                  name="form-input-refreshToken"
                  v-model="itemForm.refreshToken"
                  type="password"
                      autocomplete="off"
                  v-validate="{ required: false }"
                  :state="validateState('form-input-refreshToken')"
                  data-vv-as="Refresh Token"
                  />
                <b-form-invalid-feedback id="form-input-refreshToken-feedback">
                  {{ veeErrors.first('form-input-refreshToken') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Token Expires (UTC):">
                <b-form-input
                  id="form-input-expiresUtcDateTime"
                  name="form-input-expiresUtcDateTime"
                  v-model="itemForm.expiresUtcDateTime"
                  type="datetime-local"
                  v-validate="{ required: false }"
                  :state="validateState('form-input-expiresUtcDateTime')"
                  data-vv-as="Token Expires"
                  />
                <b-form-invalid-feedback id="form-input-expiresUtcDateTime-feedback">
                  {{ veeErrors.first('form-input-expiresUtcDateTime') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <aside class="col-12 col-lg-3">
      <b-card header="Actions">
        <b-button
          :disabled="savingItem"
          variant="primary"
          block
          type="submit"
          @click="SaveForm"
        >
          <span v-if="savingItem">Saving...</span>
          <span v-else>Save Changes</span>
        </b-button>
        <router-link
          :disabled="savingItem"
          class="mt-2 btn btn-block btn-outline-danger"
          :to="{ name: 'IntegrationCarriers.Index' }"
        >
          <span>Cancel</span>
        </router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [crudMixinGen('integrationCarriers'), myCommonDataMixin],
  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: () => ({
    heading: 'Integration Config',
    processingSystemOptions: [
      { value: 'ShipEngine', text: 'ShipEngine' },
      { value: 'TechShip', text: 'TechShip' },
      { value: 'UPSDirect', text: 'UPS Direct' },
      { value: 'eHub', text: 'eHub' },
      { value: 'GlobalAccess', text: 'Global Access' },
      { value: 'Priority1', text: 'Priority 1' },
      { value: 'GLSGermany', text: 'GLS Germany' },
      { value: 'DeutschePostDHL', text: 'Deutsche Post DHL' },
      { value: 'Fedex', text: 'FedEx' },
      { value: 'GOFO', text: 'GOFO' },
      { value: 'FakeCarrier', text: 'Fake Carrier (Testing Only)' }
    ]
  }),

  computed: {
    showOAuthSection() {
      return ['UPSDirect'].includes(this.itemForm.processingSystem);
    },
    tplCarrierList: {
      get() {
        let itmsList = [];
        let myItems = this.$store.getters.getMyTPL.carriers;
          itmsList.push({ value: null, text: '- Multiple -' });
        myItems.forEach(itm => {
          itmsList.push({ value: itm.id, text: itm.name  +  ' (' + itm.description+ ')' });
        });
        return itmsList;
      },
      set(val) {
      }
    },
  },

  mounted() {
    this.$store.dispatch('fetchMyTPLData');
    if (this.id) {
      this.ResetForm();
      this.LoadItem(this.id)
    } else {
      this.ResetForm();
    }
  },

  methods: {
    getApiConfigHeader() {
      const headers = {
        'ShipEngine': 'ShipEngine Configuration',
        'TechShip': 'TechShip Configuration',
        'UPSDirect': 'UPS Direct Configuration',
        'eHub': 'eHub Configuration',
        'GlobalAccess': 'Global Access Configuration',
        'Priority1': 'Priority 1 Configuration',
        'GLSGermany': 'GLS Germany Configuration',
        'DeutschePostDHL': 'Deutsche Post DHL Configuration',
        'Fedex': 'FedEx Configuration',
        'GOFO': 'GOFO Configuration',
        'FakeCarrier': 'Fake Carrier Configuration'
      };
      return headers[this.itemForm.processingSystem] || 'API Configuration';
    },

    SaveForm() {
      this.savingItem = true;
      this.SaveItem()
        .then(resp => {
          this.ResetForm();
          this.$swal({ title: 'Integration Carrier Was Saved!', icon: 'success' });
          this.$router.push({
            name: 'IntegrationCarriers.Index'
          });
        })
        .catch(err => {
          this.savingItem = false;
          if (err.response && err.response.data && err.response.data.errorMessage) {
            this.$swal({ title: err.response.data.errorMessage, icon: 'error' });
          } else {
            this.$swal({ title: 'Integration Carrier Was NOT Saved!', icon: 'error' });
          }
        });
    }
  }
};
</script>